import NavBarMobile from "./NavBarMobile";
import NavBarTab from "./NavBarTab";
import NavBarDesk from "./navBarDesk";
import { useMediaQuery } from "@mui/material";
const NavBar = () => {
  const mobileQuery = useMediaQuery("(min-width:768px)");
  const tabQuery = useMediaQuery("(min-width:1440px)");

  if (!mobileQuery) {
    return <NavBarMobile />;
  } else if (!tabQuery) {
    return <NavBarTab />;
  }
  return <NavBarDesk />;
};

export default NavBar;
